<template>
  <v-container >
    <v-row>
      <v-col cols="12">
      	<v-card class="elevation-0" height="100%">
      		<v-card-title primary-title>
      		  <v-spacer></v-spacer>
      		  <h2>{{nameLab}} <v-icon color="primary" large>mdi-microscope</v-icon></h2>
      		  <v-spacer></v-spacer>
      		</v-card-title>
          <v-card-title primary-title>
            <v-text-field
              label="Buscar Articulo"
              dense
              outlined
              hide-details
              v-model="search"
              prepend-icon="search"
            ></v-text-field>
          </v-card-title>
      		<v-card-text>
    		    <v-row>
    		    	<v-col cols="12" xl="3" lg="3" md="3" sm="6" v-for="(articulo, i) in filterArticulos" :key="i" v-if="i >= countMin && i <= countMax ">
    		    		<v-hover v-slot:default="{ hover }">
    		          <v-card height="100%" v-on:dblclick="verDetalle(articulo)">
    		            <v-img 
    		            	v-if="articulo.fotos.length > 0"
    		              class="mb-4"
    		              :src="url + articulo.fotos[0].image_name" 
    		              height="200"
    		              contain>
    		            </v-img> 

    		            <v-img 
    		            	v-else
    		              class="mb-4"
    		              src="@/assets/blanco.jpg" 
    		              height="200"
    		              contain>
    		            </v-img> 
    		            
    	              <v-btn
    	                color="primary"
    	                class="buton_cart"
    	                fab
                      small
                      @click="addCarrito(articulo)"
    	              >
    	                <v-icon>mdi-cart</v-icon>
    	              </v-btn>

    		            <v-card-text class="py-0">
                      <h2>{{articulo.nomart}}</h2><br/>
                      <h3 v-if="articulo.descrip.length > 60" >{{articulo.descrip.substr(0,60)}}...</h3><br/>
                      <h3 v-if="articulo.descrip.length <= 60" >{{articulo.descrip}}</h3><br/>
                    </v-card-text>

                    <v-card-actions v-if="articulo.pjedesc > 0">
                      <strike><h4 class="primary--text mr-2">{{articulo.precio1}} MXN</h4></strike>
                    </v-card-actions>

                    <v-card-actions v-if="articulo.pjedesc > 0">
                      <h3 class="secondary--text"><b>Oferta</b> {{ articulo.prediocesc }} MXN</h3>
                    </v-card-actions>

                    <v-card-actions v-else>
                      <h3 class="primary--text mr-2">{{articulo.precio1}} MXN</h3>
                    </v-card-actions>
                  
    		          </v-card>
    		        </v-hover>
    		    	</v-col>
    		    	<v-col cols="12" align="center">
    		    		<v-pagination
    				      v-model="page"
    				      :length="paginas"
    				      :total-visible="7"
    				    ></v-pagination>
    		    	</v-col>
    		    </v-row>
      		</v-card-text>
      	</v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
	import {mapGetters, mapActions} from 'vuex'
	var numeral = require('numeral');

  export default {
    data () {
      return {
        search:'',

      	page: 1,
      	paginas:1,

      	url: '',
      	sinImagen:'@/assets/blanco.jpg',

      	countMax: 7,
      	countMin: 0,

				img: 'https://teva.niceapp.cl/wp-content//uploads/2019/03/Paracetamol_Infantil_125MG_6S_HD.jpg',

        nomlab:'',

        id:'',
        nameLab:'',

        articulos:[]


      }
    },

    watch:{
    	
      page(){
        var itemPerPage = this.page * 8
        this.countMax = itemPerPage - 1
        this.countMin = (this.countMax + 1) - 8
        console.log('cambie de pagina', this.page)
      },

      $route(){
        console.log(this.$route.params.id)
        this.init()

      }
    },

    created(){
    	this.url = this.$http.options.root + 'fotos/'
      this.init()
    },

    methods:{
      ...mapActions('carrito',['carritoadd']),

      init(){
        this.articulos = []
        this.id = this.$route.params.id
        this.$http.get('tienda/articulos.laboratorio.get/' + this.id).then(response=>{
          console.log(response.body)
          this.articulos = response.body
          this.nameLab = response.body[0].nomlab
          response.body.forEach((element,index)=>{
            element.prediocesc = element.precio1 * (  (100 - element.pjedesc) * 0.01 ) 
            element.precio1 = numeral(element.precio1).format('0,0.00')
            element.prediocesc = numeral(element.prediocesc).format('0,0.00')
          })
        })
      },

      addCarrito(art){
        // art.precio1 = this.unformat(art.precio1)
        this.carritoadd(art)
        this.$store.state.carrito.carritovisible = true
        art.precio1 = numeral(art.precio1).format('0,0.00')
      },

      unformat(string) {
        return numeral._.stringToNumber(string);
      },

      verDetalle(art){
        console.log('articulo',art)
        this.$router.push({ name: 'detart' , params:{ codigo:art.codigo} })
      },

    },

    computed:{
    	paginacion(){
    		var paginas = 0
    		if((this.getLab.length /8)%2==0){
	    		paginas = this.getLab.length /8
	    	}else{
	    		paginas = parseInt((this.getLab.length /8) + 1)
	    	}
	    	return paginas
    	},

      filterArticulos: function(){
        var me = this
        if(this.articulos){
          return this.articulos.filter((art)=>{
            var nom = art.nomart.toLowerCase();
            return nom.match(this.search.toLowerCase());
          })
        }
      },
    }

  }
</script>
<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}

.atras { 
  position: relative; 
  left: -30px; 
  top: 200px; 
  background-color: #fafafa; 
  border: solid 3px #ff7347; 
} 

.adelante { 
  position: absolute; 
  right: -30px; 
  top: 200px; 
  background-color: #fafafa; 
  border: solid 3px #78e382; 
  font-size: 24px; 
  text-align: center; 
}

.buton_cart{
	position: absolute; 
  right: 10px; 
  top:170px;
  background-color: #fafafa; 
  border: solid 3px #78e382; 
  font-size: 24px; 
  text-align: center; 
}
</style>